import { render, staticRenderFns } from "./MyPharmacy.vue?vue&type=template&id=2a08f94c"
import script from "./MyPharmacy.vue?vue&type=script&lang=js"
export * from "./MyPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports